import { Tabs } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { Completed, InProgress, NotStarted } from '../../../pages/arc/constants/constant-strings';
import { NewHireEnrollmentRoutes } from '../../../pages/arc/features/new-hire-enrollment/models/new-hire-routes';
import { buttonStyles } from '../../constants/theme/styles/components/buttonstyles';
import { genericStepperStyles } from '../../constants/theme/styles/components/generic-stepper';
import { ProgressBarStep, ProgressBarStepItem } from '../progress-bar-step';


export interface ProgressItem {
    stepName: string,
    linkUrl: string,
    step: any,
}

interface ProgressProps {
    basePath: string;
    allSteps: any[];
    useCurrentStep: any;
    setCurrentStep: any;
    progressItems: ProgressItem[];
    onCustomStepperClick?: (step: any, subPath: string) => void;
}

function GenericStepper(props: ProgressProps) {

    const { basePath, allSteps, useCurrentStep, setCurrentStep, progressItems, onCustomStepperClick } = props;
    const currentStep = useCurrentStep();
    const buttonClasses = buttonStyles();

	const classes = genericStepperStyles();
	const stepIndex = allSteps.indexOf(currentStep);
	const history = useHistory();
	const dispatch = useDispatch();
	const location = useLocation();
	const getProgress = (idx: number, current: number) => {
		if (idx === current) return InProgress;

        return idx > current ? NotStarted : Completed;
    };
    const getStepId = (idx: number, current: number) => {
        if (idx === current) return ProgressBarStep.INPROGRESS;
        return idx > current ? ProgressBarStep.NOTSTARTED : ProgressBarStep.COMPLETED;
    };

    const onStepperClick = (step: any, subPath: string) => {
        history.push(`${basePath}${subPath}`);

        if (setCurrentStep) {
            dispatch(setCurrentStep(step));
        }
    };

    const showLink = (idx: number, current: number) => {
        return idx < current;
    };


    const getStepNameNode = (name: string, link: string, step: any) => {

        if (link) {
            return (
                <button
                    className={buttonClasses.linkButton}
                    type='button'
                    onClick={() => {
                        if (onCustomStepperClick) {
                            onCustomStepperClick(step, link);
                            return;
                        }

                        onStepperClick(step, link);
                    }} >
                    {name}
                </button>
            );
        }

        return (
            <p>{name}</p>
        );
    };

	if (!(progressItems?.length > 0) || location?.pathname?.includes(NewHireEnrollmentRoutes.Confirmation)) return null;

    return (
        <div className={classes.genericStepperContainer}>
            <Tabs
                value={stepIndex > -1 ? stepIndex : 0}
                variant="scrollable"
                scrollButtons
                className='generic-stepper-bar'
            >
                {
                    progressItems?.map((item, idx) =>
                        <ProgressBarStepItem
                            key={`${item?.stepName}-${idx}`}
                            stepNameNode={
                                getStepNameNode(
                                    item?.stepName,
                                    showLink(idx, stepIndex) && item?.linkUrl,
                                    item?.step,
                                )
                            }
                            progress={getProgress(idx, stepIndex)}
                            stepId={getStepId(idx, stepIndex)}
                        />)

                }
            </Tabs>
        </div>
    );
}

GenericStepper.defaultProps = {
    onCustomStepperClick: null,
};

export default GenericStepper;

